import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=26cfa47e&scoped=true&lang=pug&"
import script from "./ButtonBack.vue?vue&type=script&lang=ts&"
export * from "./ButtonBack.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBack.vue?vue&type=style&index=0&id=26cfa47e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cfa47e",
  null
  
)

export default component.exports